<template>
    <v-autocomplete
        :items="garages"
        item-value="id"
        item-text="location"
        v-model="garage"
        name="garage"
        placeholder="Select a garage"
        hide-details
        solo
    ></v-autocomplete>
</template>
<script>
import { GarageLocationStore } from '../../stores/GarageLocationStore';
import UsersClient from '@/components/Users/UsersClient.vue';
import { Event, EventBus } from '../../plugins/bus';

export default {
    mixins: [UsersClient],
    data: () => ({
        garagesStore: GarageLocationStore.data,
        garage: null,
        user: null
    }),
    computed: {
        garages() {
            return GarageLocationStore.data.garages.filter(r => this.garageIds.find(v => v === r.id));
        },
        garageIds() {
            return this.user ? this.user.garages : [];
        },
        userGarage() {
            return this.garagesStore.userGarage;
        }
    },
    async mounted() {
        this.user = await this.getCurrentUser();
        // select the first garage if only one user garage exists
        if (!this.userGarage) {
            if (!!this.user) {
                if (this.garageIds.length === 1) {
                    GarageLocationStore.methods.updateUserGarage(this.garageIds[0]);
                }
            }
        }

        this.garage = this.garagesStore.userGarage;
    },
    watch: {
        garage(val) {
            GarageLocationStore.methods.updateUserGarage(this.garage);
            EventBus.$emit(Event.GarageSelected, val);
        }
    }
};
</script>
